import api from './api';

export const openaiService = {
  async sendMessage(message, context, portfolioData = null) {
    try {
      const response = await api.post('/ai/chat?provider=openai', {
        message,
        context,
        portfolioData: portfolioData || null
      });

      if (!response || !response.content) {
        throw new Error('Empty response from AI service');
      }

      return response.content;
    } catch (error) {
      console.error('OpenAI API error:', error);
      throw error;
    }
  }
};